module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    ref: "main",
    staticClass: "project project__hoverclass",
    style: (_vm.styles),
    attrs: {
      "tag": "div",
      "to": {
        name: 'portfolio.showcase',
        params: {
          name: _vm.project.title,
          index: _vm.project.index
        },
        meta: {
          project: _vm.project
        }
      }
    }
  }, [_c('div', {
    staticClass: "text-area",
    attrs: {
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "words title"
  }, [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.project.title))])]), _c('div', {
    staticClass: "words description"
  }, [_c('p', {
    staticClass: "desc-text"
  }, [_vm._v(_vm._s(_vm.project.description))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d8c7ce8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project.vue
// module id = 375
// module chunks = 1